const int32 = (x) => x | 0;

export default int32;
